/**
 * 错误模块类型定义
 * @module types/error
 */

// ============================================
// 自定义错误类
// ============================================

/**
 * CSD SDK 错误类
 * 用于封装 API 错误和业务错误
 */
export class CsdError extends Error {
  /** 错误码 */
  public code: number
  /** 原始响应 */
  public response?: unknown

  constructor(message: string, code: number, response?: unknown) {
    super(message)
    this.name = 'CsdError'
    this.code = code
    this.response = response

    // 保持正确的原型链
    Object.setPrototypeOf(this, CsdError.prototype)
  }

  /** 转换为 JSON */
  toJSON() {
    return {
      name: this.name,
      code: this.code,
      message: this.message,
      response: this.response
    }
  }
}

/** @deprecated 使用 CsdError 代替 */
export const SDKError = CsdError

// ============================================
// 错误响应
// ============================================

/** 错误响应格式 */
export interface ErrorResponse {
  /** 错误码 */
  code: number
  /** 错误消息 */
  message: string
  /** 错误数据 */
  data?: unknown
}
